import styled from 'vue-styled-components'

const Wrapper = styled.div`
`
const DetailType = styled.span`
font-size: 16px;
`
const CollapseContainer = styled.div`
margin-top: 16px;
margin-bottom: 16px;
border-radius: 5px;
`

const CollapseSpaceDefault = styled.div``
const CollapseBody = styled.div`
position: relative;
/* padding: 12px 16px; */
border-bottom: 1px solid #ebedef;
background-color: var(--light);
padding: 4px;
&::before{
    width: 4px;
    content: '';
    position: absolute;
    height: 100%;
    background-color: #24BEE2;
    left: 0;
    top: 0;
    transition: width 0.2s ease;
}
`

const CollapseSection = styled(CollapseSpaceDefault)`
position: relative;
border-top: 1px solid #ebedef;
&::before{
        content: '';
        position: absolute;
        left:0;
        top: 0;
        background-color: #007bff;
        width: 0px;
        height: 100%;
        transition: width 0.1s ease;
    }
&.hover{
    background-color: #f5f6f7;
}
&.active{
    &::before{
        width: 2px;
    }
}
`
const CollapseTitle = styled.div`
padding: 0;
display: flex;
align-items: center;
justify-content: space-between;
`
const CollapseHeader = styled(CollapseSpaceDefault)`
position: relative;
font-weight: 600;
padding: 10px 20px;
border-bottom: 1px solid #e6e6e6;

svg {
    transition: all 0.2s ease;
}
&[aria-expanded="true"] {
    svg {
    transform: rotateZ(180deg);
    -webkit-transform: rotateZ(180deg);
    -moz-transform: rotateZ(180deg);
    -ms-transform: rotateZ(180deg);
    -o-transform: rotateZ(180deg);
    }
}

&::before{
    width: 0px;
    content: '';
    position: absolute;
    height: 100%;
    background-color: #24BEE2;
    left: 0;
    top: 0;
    transition: width 0.2s ease;
}
&:hover, &.active {
    cursor: pointer;
    background-color: #F8F9FA;
    border-radius: 4px;
    border-bottom: 0px ;

    &::before{
        width: 4px;
    }
}
`


export {
    Wrapper,
    DetailType,
    CollapseContainer,
    CollapseHeader,
    CollapseBody,
    CollapseSection,
    CollapseTitle
}